import { defaultColumns, defaultSort } from '../../components/sales/stowages/columns';

export default {
  state: {
    stowages: [],
    tableConfig: null,
    loading: false,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'created_at',
      order: 'asc',
    },
  },
  getters: {
    stowages: state => state.stowages,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
  },
  mutations: {
    setStowages(state, stowages) {
      state.stowages = stowages;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/stowage-list');
        const tableConfig = {
          id: setting.id || null,
          type: 'stowage-list',
          columns: setting.id ? JSON.parse(setting.config).columns : defaultColumns,
          sort: setting.id ? JSON.parse(setting.config).sort : defaultSort,
        };
        commit('setTableConfig', tableConfig);
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&comparetype=${state.sorting.compareType || 'string'}&${state.filterString}`;
        const stowages = await axios.get('api/stowages' + (query || ''));
        commit('setStowages', stowages);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async search({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        return await axios.get('api/stowages/search' + (queryString || ''));
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetch({ commit }, id) {
      return await axios.get(`api/stowages/${id}`);
    },
    async search({ commit, state, dispatch }, queryString) {
      try {
        return await axios.get('api/stowages/search' + (queryString || ''));
      } catch (e) {
      }
    },
    async print({ commit }, payLoad) {
      return await axios.post('api/stowages/print', payLoad, {
        responseType: 'arraybuffer',
        headers: {
          'Accept': 'application/pdf'
        },
      });
    },
    async create({ commit }, payLoad) {
      await axios.post('api/stowages', payLoad);
    },
    async close({ commit }, id) {
      return await axios.post(`api/stowages/close/${id}`);
    },
    async update({ commit }, payLoad) {
      await axios.put('api/stowages', payLoad);
    },
    async delete({ commit }, id) {
      await axios.delete(`api/stowages/${id}`);
    },

    async excelExport({ commit }, { data, fileName, fileFormat }) {
      const excel = await axios({
        url: 'api/stowage-excel-export',
        method: 'POST',
        responseType: 'blob',
        data,
      });
      saveAs(excel, `${fileName.trim().split(' ').join('_') || 'Stowages'}.${fileFormat.toLocaleLowerCase() || 'xlsx'}`);
    },

    async getPreviewData({ commit }, { formData }) {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };
      const response = axios.post('api/stowage-import-preview', formData, config);

      return response
    },

    async import({ commit }, data) {
      const response = axios.post('api/stowage-import', data);

      return response
    },
  },
};
